import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class PendingService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) { }

  public searchFilters = {}

  public campaignFormTextFieldTemplate = `
    <div class='row justify-content-center'>
      <div class='col-11'>
          <div class='md-form no-bottom-margin'>
              <input id='%id%' type='text' maxlength='256' class='form-control validate mb-0'>
              <label id='%id%Label' class='inputLabel pr-4' data-error='Invalid' data-success='' for='%id%'>
                  %label%
              </label>
              <div class='body-2 mt-3 ml-2'>%desc%</div>
          </div>
      </div>
    </div>`;

  public campaignFormSelectFieldTemplate = `
  <div class="row justify-content-center">
    <div class="col-11">
        <fieldset class='form-group noMargin' style='margin-bottom: 2rem;'>
            <div class='row'>
                <div class='col text-left'>
                    <div class='text-left ml-2 mb-1' style='color: #757575; font-size: 0.8rem;'>%label%</div>
                </div>
            </div>
            <select id='%id%' class='select-wrapper mdb-select mdb-select--paybee'>
                %options%
            </select>
            <small id='%id%Error' style='display:none' class='red-text text-left mt-1 ml-2'></small>
            <div class='body-2 mt-1 ml-2'>%desc%</div>
        </fieldset>
    </div>
  </div>`;

  public campaignFormAddressFieldTemplate = `
  <div class='row justify-content-center'>
    <div class="col-11 d-flex">
        <div class="col-6 pl-0">
            <div class='md-form mb-4'>
                <div class="position-relative">
                    <input id='%id%' autocomplete='off' onfocus="this.setAttribute('autocomplete','chrome-off')"
                        class='form-control validate mb-0'
                        placeholder=''
                        type='text'
                    >
                    <label id='%id%Label' class='inputLabel pr-4' for='%id%' data-error='Invalid' data-success=''>
                        %label%
                    </label>
                    <button id='%id%CancelBtn' type="button" class="btn--reset-address">
                        <i class="fas fa-times black-text"></i>
                    </button>
                </div>
                <div class='body-2 mt-3 ml-2'>%desc%</div>
            </div>
        </div>
        <div class="col-6 pr-0">
            <div class='md-form mb-4'>
                <input class='form-control mb-0' type='text' id='%id%Unit'>
                <label id='%id%UnitLabel' class='inputLabel pr-4' for='%id%Unit' data-error='Invalid' data-success=''>
                    Unit/Apartment# (optional)
                </label>
            </div>
        </div>
    </div>
  </div>
   `;

  public campaignFormPhoneNumberFieldTemplate = `
    <div class="row justify-content-center">
      <div class="col-11">
          <div class='md-form'>
              <input id='%id%' type='tel'class='form-control validate mb-0'>
              <label id='%id%Label' class='inputLabel pr-4' for='%id%' data-error='Invalid' data-success=''>
                  %label%
              </label>
              <div class='body-2 mt-3 ml-2'>%desc%</div>
          </div>
      </div>
    </div>`;

  getReport() {
    const token = this.cookieService.get('accessToken');
    return this.http.post('/api/report/allPendingCarts', `access_token=${token}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
  
  getallPendingItemsReport() {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`
    ];
    return this.http.post('/api/report/pending/all', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  addToCart(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/cart/add', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  addOnDonation(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/org/cart-add-on-donation/enable', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  saveSearch(name,query){
    this.searchFilters[name] = query
  }

  getSearchQuery(name){
    return this.searchFilters[name]
  }

  clearSearchQuery(){
    this.searchFilters = {}
  }

}
